/**
 * Chair Dinkum - Gas Lift Page Add-on
 * Adds unblocking tool as a purchasable option below the colour selector
 * Only runs on /products/hag-capisco-gas-lift
 */
(function() {
  'use strict';

  if (window.location.pathname.indexOf('/products/hag-capisco-gas-lift') === -1) return;

  var TOOL_HANDLE = 'hag-gas-lift-unblocking-tool';
  var TOOL_VARIANT_ID = 42261680619575;
  var TOOL_PRICE = 45;

  function init() {
    // Find the buy buttons / add to cart area
    var form = document.querySelector('form[action="/cart/add"]');
    if (!form) { setTimeout(init, 500); return; }

    // Find the variant picker fieldset (colour selector)
    var variantPicker = form.querySelector('.variant-wrapper, fieldset, [data-option-index]');
    var buyBtn = form.querySelector('[type="submit"], .btn--add-to-cart, .add-to-cart');

    // Create the add-on container
    var container = document.createElement('div');
    container.id = 'cd-gaslift-addon';
    container.style.cssText = 'margin:16px 0;padding:16px;border:1px solid #e8e8e8;border-radius:6px;';

    var label = document.createElement('label');
    label.style.cssText = 'display:flex;align-items:flex-start;gap:10px;cursor:pointer;';

    var checkbox = document.createElement('input');
    checkbox.type = 'checkbox';
    checkbox.id = 'cd-add-unblocking-tool';
    checkbox.style.cssText = 'margin-top:3px;width:18px;height:18px;flex-shrink:0;accent-color:#000;';

    var textWrap = document.createElement('div');
    textWrap.innerHTML = '<p style="margin:0;font-weight:500;font-size:0.9rem;">Add Gas Lift Unblocking Tool (+$' + TOOL_PRICE + '.00)</p><p style="margin:4px 0 0 0;font-size:0.8rem;color:#666;line-height:1.4;">Needed to remove your existing gas lift from the chair base</p>';

    label.appendChild(checkbox);
    label.appendChild(textWrap);
    container.appendChild(label);

    // Insert before the buy button area
    if (buyBtn && buyBtn.closest('.product-block')) {
      buyBtn.closest('.product-block').before(container);
    } else if (buyBtn) {
      buyBtn.parentElement.before(container);
    } else {
      // Fallback: append to form
      form.appendChild(container);
    }

    // Intercept form submission to add the tool to cart
    form.addEventListener('submit', function(e) {
      if (!checkbox.checked) return; // Let normal submission happen

      e.preventDefault();
      e.stopPropagation();

      // Get the main product variant ID from the form
      var mainVariantInput = form.querySelector('select[name="id"], input[name="id"]');
      var mainVariantId = mainVariantInput ? mainVariantInput.value : null;

      if (!mainVariantId) return;

      // Add both items to cart
      var items = [
        { id: parseInt(mainVariantId), quantity: 1 },
        { id: TOOL_VARIANT_ID, quantity: 1 }
      ];

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
      .then(function(response) {
        if (response.ok) {
          window.location.href = '/cart';
        } else {
          // Fallback: just submit normally
          checkbox.checked = false;
          form.submit();
        }
      })
      .catch(function() {
        checkbox.checked = false;
        form.submit();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
